import { convertFirebaseDateToLocal } from "@/firebase/utils";
import { Profile } from "@/store/auth/state";
import {
  ChatTypes,
  MessageType,
  GroupRawAudioMessage,
  AudioMessage,
  GroupRawChat,
} from "@/store/chats/types";
import { User } from "@/store/users/state";
import { getGroupMessageReadBy } from "../chat/getGroupMessageReadBy";
import { getReadGroupMessage } from "../chat/getReadGroupMessage";
import { getSenderName } from "../chat/getSenderName";
import { findUserById } from "../users";
import { getNonAutomaticReplyMessage } from "./getNonAutomaticReplyMessage";

interface ConvertRawGroupAudioMessageArgs {
  rawMessage: GroupRawAudioMessage;
  rawChat: GroupRawChat;
  auth: Profile;
  users?: User[];
  ignoreReplies: boolean;
}

export const convertRawGroupAudioMessage = ({
  rawMessage,
  rawChat,
  auth,
  users,
  ignoreReplies,
}: ConvertRawGroupAudioMessageArgs): AudioMessage => {
  const { members: memberIds } = rawChat;
  const members: User[] = memberIds
    .map((memberId) => {
      const user = findUserById(memberId, users);
      return user;
    })
    .filter(Boolean) as User[];
  const {
    senderId,
    attachments,
    hide,
    sentAt,
    id,
    reactions,
    replyToMessage,
    isDeleted,
    isForwarded,
  } = rawMessage;
  const hidden = Boolean(hide) && !attachments?.length;

  return {
    chatType: ChatTypes.GROUP_CHAT,
    id,
    senderId,
    senderName: getSenderName(senderId, auth.id, members),
    isMine: auth.id === senderId,
    sentAt: convertFirebaseDateToLocal(sentAt),
    hidden,
    readBy: getGroupMessageReadBy(rawMessage),
    read: getReadGroupMessage(rawMessage, auth),
    attachments,
    type: MessageType.Audio,
    reactions,
    replyToMessage: getNonAutomaticReplyMessage({
      rawMessage: replyToMessage,
      rawChat,
      users,
      ignoreReplies,
    }),
    isDeleted,
    isForwarded,
  };
};
